export default __webpack_public_path__ + "static/media/Mark-3-HUD-12.b3291fea.jpg";